import React from "react";

import { Script } from "gatsby";
import PropTypes from "prop-types";

import Breadcrumb from "../../components/breadcrumb/breadcrumb";
import getInternalLinkById from "../../utils/getInternalLinkById";
import getSitePages from "../../utils/getSitePages";
import { startCase } from "../../utils/stringUtilHelper";

const BreadcrumbGenerator = ({ lastItemAs = "li", id }) => {
  const data = getSitePages();

  if (id) {
    const node = getInternalLinkById(id);

    if (node) {
      const slugParts = node.slug.split("/");
      // Remove first empty element
      slugParts.shift();

      const items = [];
      let slug = "";

      if (slugParts.length > 0 && slugParts[0]) {
        slugParts.forEach((slugPart) => {
          slug += `/${slugPart}`;
          const tmpNode = data.links.nodes.find((child) => child.slug === slug);

          if (tmpNode) {
            items.push({ link: tmpNode.slug, title: tmpNode.title });
          } else {
            items.push({ title: startCase(slugPart) });
          }
        });
      }

      const itemListElement = [{
        "@type": "ListItem",
        item: process.env.GATSBY_SITE_URL,
        name: "Home",
        position: "1",
      }];

      items.forEach((item, index) => {
        itemListElement.push({
          "@type": "ListItem",
          item: `${process.env.GATSBY_SITE_URL}${item.link}`,
          name: item.title,
          position: (index + 2).toString(),
        });
      });

      return (
        <>
          <Breadcrumb items={items} lastItemAs={lastItemAs} />

          <Script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                itemListElement,
              }),
            }}
          />
        </>
      );
    }
  }

  return null;
};

BreadcrumbGenerator.propTypes = {
  id: PropTypes.string.isRequired,
  lastItemAs: PropTypes.oneOf(["h1", "li"]),
};

export default BreadcrumbGenerator;
